import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Smoothly scroll to the element matching the current location hash and flash it. */
export function useHashScroll() {
  const { hash } = useLocation();

  useEffect(() => {
    if (typeof window === "undefined") return;
    const id = (hash || window.location.hash || "").replace("#", "");
    if (!id) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    const tryScroll = (attempt = 0) => {
      const el = document.getElementById(id);
      if (!el) {
        if (attempt < 10) requestAnimationFrame(() => tryScroll(attempt + 1));
        return;
      }
      el.scrollIntoView({ behavior: "smooth", block: "start" });
      el.classList.remove("anchor-flash");
      void el.offsetWidth;
      el.classList.add("anchor-flash");
    };
    tryScroll();
  }, [hash]);
}
